import { Button, Container, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { useState } from "react";
// import TrackVisibility from "react-on-screen";
import {toast} from "react-toastify"
// import axios from 'axios'

const useStyles = makeStyles ((theme) => ({
  contact: {
    // height: "100vh",
    backgroundColor: "#fff",
    padding: '80px 0',
    opacity: '0.85',
    // border: "1px solid yellow"
    },
  formLabel: {
    fontFamily: 'Inter',
    fontWeight: '500',
    display: 'block',
    margin: '5px 0',
    color: '#000'
  },
  formInput: {
    display: 'block',
    borderRadius: '5px',
    border: '1px solid',
    width: '100%',
    height: '50px',
    padding: '0 20px',
    borderImage: 'none',

    '&:hover': {
      border: '2px solid',
      borderColor: '#fca311 !important'
    },
    '&.active': {
      border: '2px solid #fca311 !important',
      borderColor: '#fca311',
      borderImage: 'none',
    }
  },
  formTextarea: {
    display: 'block',
    borderRadius: '5px',
    border: '1px solid',
    width: '100%',
    height: '100px',
    padding: '20px 20px',
    borderImage: 'none',

    '&:hover': {
      border: '2px solid',
      borderColor: '#fca311 !important'
    },
    '&:active': {
      border: '2px solid #fca311 !important',
      borderColor: '#fca311 !important',
      borderImage: 'none',
    },
    '&:focus': {
      border: '2px solid #fca311 !important',
      borderColor: '#fca311 !important',
      borderImage: 'none',
    },
    '&:userselected': {
      border: '2px solid #fca311',
      borderColor: '#fca311',
      borderImage: 'none',
    }
  },
  formButton: {
    backgroundColor: '#fca311',
    color: '#000',
    outline: 'none',
    borderRadius: '2px',
    width: '150px',
    // padding: '.7em 2em',
    letterSpacing: '1px',
    fontWeight: 700,
    height: '50px',
    marginTop: '10px',

    "&:hover": {
      backgroundColor: '#0000',
      color: '#ffff'
    }
  },
  brandBox: {
    width: {xs: '80% !important', sm: '80% !important', md: '85% !important'} ,
    margin: '0 auto !important',
    background: 'linear-gradient(90.12deg, rgba(35, 77, 124, 0.5) -100.91%, rgba(70, 237, 200, 0.5) 111.58%)',
    padding: '2.5em 2em',
    borderRadius: '50px',
    display: 'flex',
    flexDirection: {
      xs: 'column !important',
      sm: 'column !important',
      md: 'row !important'
    },
    justifyContent: 'space-between'
    // marginTop: '-200px',
    // zIndex: 1,
  }
}));

const Contact = () => {
  const formInitialDetails = {
    name: '', email: '', budget: '', message: ''
  };
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttontext, setButtonText] = useState('Send');
  const [errors, setErrors] = useState({});

  const validate = () => {
    let errors = {};

    if (!formDetails.name.trim()) {
      errors.name = 'Name is required';
    }

    if (!formDetails.email) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formDetails.email)) {
      errors.email = 'Email is invalid';
    }

    if (!formDetails.budget) {
      errors.budget = 'selected budget is required';
    }

    if (!formDetails.message.trim()) {
      errors.message = 'Message is required';
    }

    return errors;
  }

  const onFormUpdate = (e) => {
    setFormDetails({ ...formDetails, [e.target.name]: e.target.value});
    setErrors({ ...errors, [e.target.name]: ''});
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = validate();
    
    

    if (Object.keys(errors).length > 0) {
      setErrors(errors)
    } else {
      setButtonText('Sending...');
      fetch('http://localhost:5000/contact', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(formDetails)
      })
        .then((response) => response.json())
        .then((data) => 
          console.log(data),
          // setFormDetails(data),
          toast.success('Form Submited succesfully')
        )
        .catch((error) => console.error(error))
    }
    setButtonText('Send');
    setFormDetails(formInitialDetails);
  };
 
  const classes = useStyles();

  return (
    <div className={`${classes.contact} ${'contact'}`} id="contact">
      {/* <ToastContainer position='bottom-center' /> */}
      <div style={{ marginTop: '-200px', zIndex: '1', position: 'relative'}}
      >
        <Box 
          sx={{
            background: '#000',
            display: 'flex',
            alignItems: 'center',
            flexDirection: {xs: 'column', sm: 'row', md: 'row'},
            width: {xs: '90%', sm: '80%', md: '70%'},
            margin: '0 auto',
            padding: {xs: '2.5em 2em', sm: '3.5em 3em'},
            borderRadius: '50px',
          }}
        >
          <div style={{flex: 1}}>
            <Typography variant='h3' 
              style={{fontSize: '36px', color: '#fff', fontWeight: 700, letterSpacing: '0.75px', width: '80%', marginBottom: '30px'}}
            >
              Give Your Brand the Edge That it Needs.
            </Typography>
          </div>
          <div style={{flex: 1}}>
            <Typography variant='body2' 
              style={{
                fontFamily: 'Inter',
                fontSize: '18px', 
                color: '#fff', 
                fontWeight: '500', 
                width: '100%'
              }}
            >
              with over 3 years of experience in Technical Support 
              and Frontend Development.
            </Typography>
          </div>
        </Box>
      </div>

      <Box sx={{textAlign:'center', marginBottom: '30px'}}>
        {/* <Typography variant='h2' style={{color: '#000', fontSize: '45px', fontWeight:'700', }}>
          Contact
        </Typography> */}
      </Box>
      <Container>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Box 
              sx={{ 
                display: {xs: 'flex', sm: 'flex', md: 'flex' },
                flexDirection: 'column',
                justifyContent: "center", 
                alignItems: "center", 
                placeContent: 'center',
                padding:  {xs: '40px 0 0', sm: '60px 0 0', md: '90px 0 0',}
              }}
            >
              <Box>
                <Typography variant='body1' 
                  sx={{  
                    fontSize: '18px', color: '#000', fontWeight: "500", letterSpacing: '0.75px', lineHeight: '1.5em',
                    width: {xs: '100%', sm: '90%', md: '85%'}, margin: '20px auto',
                    textAlign: {xs: 'center', sm: 'center', md: 'center'}
                  }}
                >
                  As a web developer, I bring a professional and personable approach to every project. My focus is on delivering practical, user-friendly applications that can evolve to meet changing needs. But I also believe that blending creativity and customer experience is key to delivering truly engaging projects. I take pride in finding innovative solutions that exceed my clients' expectations and help them stand out in a crowded digital landscape. 
                </Typography>
              </Box>
              <Box>
                <Typography variant='body1' 
                  sx={{ fontSize: '18px', color: '#000', fontWeight: "500", letterSpacing: '0.75px', lineHeight: '1.5em', width: {xs: '100%', sm: '90%', md: '85%'}, margin: '20px auto', textAlign: {xs: 'center', sm: 'center', md: 'center'}}}
                >
                  With my skills and passion for creating visually stunning and fully-functional projects, I'm confident that I can bring your vision to life. Let's collaborate to build something amazing that delights your users and drives your business forward. Get in touch to start the conversation today!                  
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            {/* <TrackVisibility> */}
              {/* {({ isVisible}) =>  */}
                <div 
                // className={isVisible ? "animate__animated animate__backInRight animate__delay-2s" : ""} 
                  style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}
                >
                  <div>
                    <Typography variant='h3' 
                      sx={{
                        color: '#000', fontSize: '36px', fontWeight: '700', letterSpacing: '0.75px', textAlign: 'center', margin: '20px 0',
                      }}
                    >
                      Let's Talk
                    </Typography>
                    <Typography variant='body2' style={{color: '#000', fontSize: '16px', fontWeight: '500', width: '80%', margin: '0 auto', textAlign: 'center'}}
                    >
                      Tell me all about your project right here, or send me an email at {' '}
                      <a href="https://gmail.com" target='_blank' rel="noreferrer" style={{color:'#fca311'}}>aniekan.g.edet@gmail.com</a>
                    </Typography>
                  </div>
                  <div style={{margin: '20px 0'}}>
                    <form onSubmit={handleSubmit}>
                      <div style={{marginBottom: '10px'}}>
                        <label className={classes.formLabel}>Name & Company</label>
                        <input type='text' 
                          className={classes.formInput} 
                          name="name"
                          value={formDetails.name} 
                          onChange={onFormUpdate} placeholder='John Smith from Company Inc.' 
                        />
                        {errors.name && <span style={{color: 'red'}}>{errors.name}</span>}
                      </div>
                      <div style={{marginBottom: '10px'}}>
                        <label className={classes.formLabel}>Email</label>
                        <input type='email' 
                          className={classes.formInput} 
                          name="email"
                          value={formDetails.email} 
                          onChange={onFormUpdate} placeholder='johnSmith@companyinc.co' 
                        />
                        {errors.email && <span style={{color: 'red'}}>{errors.email}</span>}
                      </div>
                      <div style={{marginBottom: '10px'}}>
                        <label className={classes.formLabel}>Budget</label>
                        <select type='text' 
                          className={classes.formInput} 
                          name="budget"
                          value={formDetails.budget} 
                          onChange={onFormUpdate} placeholder='Select budget amount' 
                        >
                          <option>$200 - $500</option>
                          <option>$500 - $1000</option>
                          <option>$1000 - $1500</option>
                          <option>$1500+</option>
                        </select>
                        {errors.budget && <span style={{color: 'red'}}>{errors.budget}</span>}
                      </div>
                      <div style={{marginBottom: '10px'}}>
                        <label className={classes.formLabel}>Message</label>
                        <textarea type='text' 
                          className={classes.formTextarea} 
                          name="message"
                          value={formDetails.message} 
                          onChange={onFormUpdate} placeholder='We need to launch a landing page for our product' 
                        />
                        {errors.message && <span style={{color: 'red'}}>{errors.message}</span>}
                      </div>
                      <div style={{marginTop: '10px'}}>
                        <Button type="submit" variant='contained'
                          style={{
                            fontFamily: 'Inter',
                            backgroundColor: '#fca311',
                            color: '#000',
                            outline: 'none',
                            borderRadius: '5px',
                            width: '150px',
                            padding: '.7em 2em',
                            letterSpacing: '1px',
                            fontWeight: 700,
                            height: '50px',
                            marginTop: '10px',
                            '&:hover': {
                              backgroundColor: '#fff',
                              color: '#20c4c6'
                            }
                          }}>
                          <span>{buttontext}</span>
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              {/* } */}
            {/* </TrackVisibility> */}
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default Contact